import './pagination.css';
import styled from 'styled-components';
import ReactPaginate from 'react-paginate';
import { H1 } from 'xpi-black-ui/Base/Typography';

const Pagination = styled(ReactPaginate).attrs(() => ({
  containerClassName: 'container',
  breakLinkClassName: 'page-break-number',
  previousLinkClassName: 'page-link-previous',
  nextLinkClassName: 'page-link-next',
  pageLinkClassName: 'page-link-number',
  pageClassName: 'page-number',
  activeClassName: 'page-active-number',
  previousClassName: 'page-previous',
  nextClassName: 'page-next',
  disabledClassName: 'page-disabled-previous-and-next',
  breakLabel: '...',
  nextLabel: 'Próxima >',
  previousLabel: '< Anterior',
}))``;

export default Pagination;

export const MainContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem 2.5rem;

  ul {
    display: flex;
    flex-direction: row;
  }
`;

export const OperationContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const OperationGridContainer = styled(MainContainer)`
  gap: 1rem;
`;

export const SectionTitle = styled(H1)`
  text-transform: capitalize;
`;

export const CardContainer = styled.div`
  margin-right: 10px;
`;
